<template>
  <modal
    header-text=""
    :button-text="$t('global.save')"
    @action="$emit('save')"
    @close="$emit('cancel')"
  >
    <div :class="$style.inputContainer">
      {{ $t('modal.saveChangesForProfile') }} {{ selected }}?
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/settings-modal.vue';

export default {
  components: { Modal },
  props: ['selected'],
};
</script>

<style lang="scss" module>
.inputContainer {
  font-size: 13px;
  margin: 5px;
}
</style>
